import { Controller } from '@hotwired/stimulus';
import Axios from '../axios';

export default class extends Controller {
	connect() {
		this._suggestionsList = document.createElement('ul');
		this._suggestionsList.classList.add('suggestions');
		this._suggestionsList.style.display = 'none';

		this.element.parentNode.insertBefore(this._suggestionsList, this.element.nextSibling);
		this._suggestionsList.addEventListener('click', (e) => {
			this.selectItem(e.target);
		});

		this._list = [];
		this._listLoading = false;

		let debounce = null;
		this.element.addEventListener('keyup', () => {
			if (!this._listLoading) {
				this.listLoading();
			}

			clearTimeout(debounce);
			let value = this.element.value;

			debounce = setTimeout(async () => {
				this._list = await this.fetchList(value);
				this.changeAutocomplete();
				this._listLoading = false;
			}, 200);
		});
	}

	async fetchList(q) {
		let response;
		response = await Axios.get(`${this.element.dataset.route}?q=${q}`);

		return response.data.data.list;
	}

	changeAutocomplete() {
		this._suggestionsList.innerHTML = '';
		this._suggestionsList.classList.remove('loading');

		if (this.element.value) {
			this._list.forEach(item => {
				this.addItem(item);
			});

			this._suggestionsList.style.display = 'block';
		} else {
			this._suggestionsList.innerHTML = '';
		}
	}

	addItem(item) {
		this._suggestionsList.innerHTML = this._suggestionsList.innerHTML + `<li>${item.title}</li>`;
	}

	selectItem(target) {
		if (target.tagName === 'LI') {
			this.element.value = target.textContent;
			this._suggestionsList.style.display = 'none';
		}
	}

	listLoading() {
		this._listLoading = true;
		this._suggestionsList.style.display = 'block';
		this._suggestionsList.classList.add('loading');
		this._suggestionsList.innerHTML = '<li></li>';
	}
}
